import { Alert, Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { FormEvent, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import styles from './TV.module.scss';

const TVComponent = () => {
  const { consumeTvLoginCode, subscription } = useFirebase();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [result, setResult] = useState<boolean>(null);
  const { t } = useTranslation();

  const submitLoginCode = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setResultModalOpen(false);
    setResult(null);
    consumeTvLoginCode(code).then((result) => {
      setLoading(false);
      setResult(result);
      setResultModalOpen(true);
    });
  };

  return (
    <AppShell>
      <div className={'d-flex flex-column flex-grow-1'}>
      <Title>{t('tv.labels.title')}</Title>

      <Container className={'flex-grow-1'}>
        {!!subscription ? (
          <Form onSubmit={submitLoginCode} className={styles.loginCodeForm}>
            <InputGroup size={'lg'} className={styles.loginCodeInput}>
              <Form.Control
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                autoFocus
                placeholder={t('tv.labels.inserisciCodice')}
                maxLength={6}
                minLength={6}
                onInvalid={(e) =>
                  e.currentTarget.setCustomValidity(
                    e.currentTarget.validity.valueMissing ? t('tv.labels.codiceObbligatorio') : t('tv.labels.codiceTroppoCorto'),
                  )
                }
                onInput={(e) => e.currentTarget.setCustomValidity('')}
              />
            </InputGroup>
            <Button variant={'primary'} className={`tootor-button tootor-button--primary ${styles.confirmButton}`} type={'submit'} disabled={loading}>
              {t('labels.conferma')}
            </Button>
          </Form>
        ) : (
          <Alert variant={'warning'} className={'mb-0'}>
            {t('tv.labels.necessarioAbbonamentoAttivo')}
          </Alert>
        )}
      </Container>

      <Footer />

      <Modal className="tootor-modal" show={resultModalOpen} onHide={() => setResultModalOpen(false)}>
        <Modal.Header>
          <Modal.Title>{result ? t('tv.labels.operazioneSuccesso') : t('errorModal.labels.codiceNonValido')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {result && <div>{t('tv.labels.codiceValido')}</div>}
          {!result && <div>{t('tv.labels.codiceNonValido')}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button className="tootor-button tootor-button--basic" onClick={() => setResultModalOpen(false)}>
            {t('labels.chiudi')}
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
    </AppShell>
  );
};

export default TVComponent;
